/*
 * Copyright 2021 Larder Software Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useCallback } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { handleError } from './utils';
import { jiraApiRef } from '../api';

export const useStatuses = (projectKey: string) => {
  const api = useApi(jiraApiRef);

  const getStatuses = useCallback(async () => {
    try {
      return await api.getStatuses(projectKey);
    } catch (err: any) {
      return handleError(err);
    }
  }, [api, projectKey]);

  const { loading, value, error } = useAsync(() => getStatuses(), []);
  return {
    statusesLoading: loading,
    statuses: value,
    statusesError: error,
  };
};
